import { Link } from 'react-router-dom';
import { site, testimonials } from '@/mocks/site';

export default function TrustSection() {
  return (
    <section className="mx-auto max-w-content px-4 md:px-6 py-14 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
            <i className="ri-chat-quote-line"></i>
            站内口碑
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            吃瓜这么多年，图的就是一个清楚
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            {site.name}从 {site.since} 年开始做事件整理。我们不追流量标题，只做两件事：把时间点对齐，把来源标清楚。
          </p>
          <Link
            to="/about"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            了解我们的内容原则
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-3 lg:grid-cols-1">
          {testimonials.map((item) => (
            <blockquote
              key={item.name}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <p className="text-sm leading-relaxed text-foreground-700">“{item.content}”</p>
              <footer className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 font-heading text-sm font-bold text-accent-900">
                  {item.name.slice(0, 1)}
                </span>
                <span className="text-xs">
                  <strong className="block text-foreground-900">{item.name}</strong>
                  <span className="text-foreground-500">{item.role}</span>
                </span>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}